import { type CopilotDefinition, PROCORE_SESSION_COOKIE_NAME } from "./types";

/**
 * The Procore side-panel surface id. Single source of truth for the string —
 * imported wherever the panel needs to identify its surface (host-context
 * store, auth gate) instead of re-declaring the literal.
 */
export const PROCORE_SURFACE = "procore-copilot" as const;

/**
 * The Procore side-panel copilot — a cross-site iframe embedded in Procore.
 * Unlike the Office add-ins it captures host context (company/project/view)
 * and is framed-only, so its embedded facet carries `capturesContext` +
 * `framedOnly` and its own `SameSite=None` session cookie. No `/copilots`
 * launch tile (it's reached from inside Procore).
 */
export const procoreCopilot: CopilotDefinition = {
  copilotId: "procore",
  displayName: "Procore",
  surfaceLabel: "Procore side panel",
  surfaces: [PROCORE_SURFACE],
  capabilities: ["procore"],
  embedded: {
    [PROCORE_SURFACE]: {
      sessionStorageKey: PROCORE_SESSION_COOKIE_NAME,
      sessionCookieName: PROCORE_SESSION_COOKIE_NAME,
      capturesContext: true,
      framedOnly: true,
    },
  },
};
